import { Chart } from "chart.js/auto";
import { useEffect, useState, useRef } from "react";
import React from "react";
import "./shadedlinechart.scss";
import "chartjs-adapter-moment";

const ShadedLineChart = (props) => {
  var cautious = props.cautious;
  var medium = props.medium;
  var optimistic = props.optimistic;
  var count = 0;
  const [cautiousData, setCautiousData] = useState([]);
  const [mediumData, setMediumData] = useState([]);
  const [optimisticData, setOptimisticData] = useState([]);
  const [lableAge, setlableAge] = useState([]);
  useEffect(() => {
    let cautiousData = [];
    let mediumData = [];
    let optimisticData = [];
    let lableAge = [];
    props?.data?.potValueLineGraph?.map((item) => {
      if (item?.strategy === "Cautious") {
        cautiousData = item?.potValues;
        lableAge = cautiousData && cautiousData?.map((item) => item?.age);
      }
      if (item?.strategy === "Medium") {
        mediumData = item?.potValues;
        lableAge = mediumData && mediumData?.map((item) => item?.age);
      }
      if (item?.strategy === "Optimistic") {
        optimisticData = item?.potValues;
        lableAge = optimisticData && optimisticData?.map((item) => item?.age);
      }
    });
    setCautiousData(cautiousData);
    setMediumData(mediumData);
    setOptimisticData(optimisticData);
    setlableAge(lableAge);
  }, [props]);
  //TO DO need to remove once the chart testing part completed
  //const labels = ["20", "30", "40", "50", "60", "70", "70", "80", "90", "100"];// eslint-disable-line

  var options = {
    type: "scatter",
    data: {
      labels: lableAge && lableAge,
      datasets: [
        {
          data: mediumData && mediumData?.map((item) => item?.potValue),
          fill: false,
          segment: medium
            ? {
                borderColor: (ctx) => {
                  if (
                    ctx.p1.parsed.x <= props?.data?.retirementAge &&
                    count < 1
                  ) {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      ++count;
                    }
                    return "#a51890";
                  } else {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      return "#151f6d";
                    } else {
                      return "#008500";
                    }
                  }
                },
              }
            : { borderColor: "transparent" },
          borderWidth: 6,
          tension: 0,
          pointRadius: 0,
          pointHoverRadius: 0,
          showLine: true,
        },
        {
          data: cautiousData && cautiousData?.map((item) => item?.potValue),
          fill: optimistic ? "" : "+1",
          segment: cautious
            ? {
                borderColor: (ctx) => {
                  if (
                    ctx.p1.parsed.x <= props?.data?.retirementAge &&
                    count < 1
                  ) {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      ++count;
                    }
                    return "#a51890";
                  } else {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      return "#151f6d";
                    } else {
                      return "#008500";
                    }
                  }
                },
              }
            : { borderColor: "transparent" },
          borderWidth: 6,
          backgroundColor: "#41e2ba80",
          pointRadius: 0,
          pointHoverRadius: 0,
          tension: 0,
          showLine: true,
        },
        {
          data: optimisticData && optimisticData?.map((item) => item?.potValue),
          fill: "-1",
          segment: optimistic
            ? {
                borderColor: (ctx) => {
                  if (
                    ctx.p1.parsed.x <= props?.data?.retirementAge &&
                    count < 1
                  ) {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      ++count;
                    }
                    return "#a51890";
                  } else {
                    if (ctx.p1.parsed.x === props?.data?.retirementAge) {
                      return "#151f6d";
                    } else {
                      return "#008500";
                    }
                  }
                },
              }
            : { borderColor: "transparent" },
          borderWidth: 6,
          backgroundColor: "#41e2ba80",
          pointRadius: 0,
          pointHoverRadius: 0,
          tension: 0,
          showLine: true,
        },
      ],
    },
    options: {
      plugins: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        tooltip: {
          enabled: true,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          border: {
            color: "#151f6d",
            width: 2,
          },
          title: {
            display: true,
            text: "Age",
            font: {
              size: 16,
              weight: "bold",
            },
            color: "#151f6d",
          },
          ticks: {
            color: "#151f6d",
            font: {
              weight: "bold",
              family: "calibri",
              size: 14,
            },
            stepSize: 1,
          },
          //TO DO need to remove once chart testing completed
          //labels: lableAge,
          //min: Math.min(...lableAge),
          //max: Math.max(...lableAge),
        },
        y: {
          beginAtZero: true,
          grid: {
            color: "#d0d2e2",
            drawTicks: false,
            lineWidth: 2,
          },
          border: {
            color: "#151f6d",
            width: 2,
          },
          title: {
            display: true,
            text: "Pot value",
            font: {
              size: 16,
              weight: "bold",
            },
            color: "#151f6d",
          },
          ticks: {
            color: "#151f6d",
            // TO DO enable while State pension includes
            //   stepSize: Math.round((68230 - 60288) / 16),
            // maxTicksLimit: 9,
            // autoSkipPadding: 100,
            callback: function (value) {
              return "£" + value / 1000 + "k";
            },
            font: {
              family: "calibri",
              size: 14,
            },
          },
        },
      },
    },
    plugins: [
      {
        id: "backgrounds",
        beforeDraw: (chart) => {
          const {
            ctx,
            scales: { x, y },
          } = chart;

          const yScale = chart.scales.y;

          const topValue = yScale.ticks[0].value;
          const bottomValue = yScale.ticks[yScale.ticks.length - 1].value;

          const xLabels = chart.scales.x;

          let width = 0;

          for (let i = 0; i < xLabels.ticks.length; i++) {
            if (i % 2 === 0) {
              if (xLabels.ticks[i + 1] !== undefined) {
                width =
                  x.getPixelForValue(xLabels.ticks[i + 1].label) -
                  x.getPixelForValue(xLabels.ticks[i].label);
              } else {
                const xAxisWidth = chart.scales["x"].right;
                const lastTickWidth = x.getPixelForValue(
                  xLabels.ticks[i].label,
                );

                width = xAxisWidth - lastTickWidth;
              }
              ctx.save();
              ctx.fillStyle = "#f8f8f8";
              ctx.fillRect(
                x.getPixelForValue(xLabels.ticks[i].label),
                y.getPixelForValue(topValue),
                width,
                y.getPixelForValue(bottomValue) - y.getPixelForValue(topValue), // eslint-disable-line
              );
              ctx.restore();
            }
          }
        },
      },
    ],
  };

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    const ctx = canvas.getContext("2d");

    const chart = new Chart(ctx, options);

    return () => {
      chart.destroy();
    };
  }, [props, cautiousData, mediumData, optimisticData, lableAge]);

  return (
    <div className="shaded-parent-chart">
      <canvas
        ref={canvasRef}
        className="shaded-line-chart"
        data-testid="shaded-line-chart"
      ></canvas>
    </div>
  );
};

export default ShadedLineChart;
